import React, { useEffect, useState } from "react";
import "./UpdateProfileModal.css";
import { Accordion, Form, Modal, Row } from "react-bootstrap";
import OrangeFilledSquareBtn from "../../Common_Btn/OrangeFilledSquareBtn/OrangeFilledSquareBtn";
import OrangeOutlineGrayFilledBtn from "../../Common_Btn/OrangeOutlineGrayFilledBtn/OrangeOutlineGrayFilledBtn";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import Orange_Round_Arrow_Btn from "../../Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import Select from "react-select";
import ProfileUpdateModal from "../ProfileUpdateModal/ProfileUpdateModal";
import { useNavigate } from "react-router-dom";
import { RegxExpression } from "../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAddressType,
  getAllDepartment,
  getAllICompanySize,
  getAllIndustry,
} from "../../../../features/master/masterSlice";

function UpdateProfileModal({ CouponData, orderData, baseLink, ...props }) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate(); // Initialize navigate function
  const [data, setData] = useState();
  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        setShowSuccessModal(false);
        navigate("/cart", {
          state: {
            data,
            CouponData,
            orderData,
          },
        });
        // Redirect to /cart after 3 seconds
      }, 3000);

      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, [showSuccessModal, navigate]);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [shwoBusinessFields, setShwoBusinessFields] = useState(false);

  // const industry = [
  //   {
  //     value: "Lykam Matte Coated",
  //     label: "Lykam Matte Coated Paper 300 Gsm Thick Card",
  //   },
  //   { value: "fashion", label: "Fashion" },
  //   { value: "home_appliances", label: "Home Appliances" },
  //   { value: "books", label: "Books" },
  //   { value: "sports", label: "Sports" },
  // ];

  const [activeBtn, setActiveBtn] = useState("Personal");
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    data.type = activeBtn;
    setData(data);
    props?.onHide();
    setShowSuccessModal(true);
    // navigate(checkOutProcessBaseLink, { state: data });
  };
  const addressType = useSelector((state) => state.master.address_type);
  const industry = useSelector((state) => state.master.industry);

  const department = useSelector((state) => state.master.department);
  const companysize = useSelector((state) => state.master.companysize);

  useEffect(() => {
    dispatch(getAllIndustry());
    dispatch(getAllDepartment());
    dispatch(getAllICompanySize());
    dispatch(getAllAddressType());
  }, [dispatch]);

  return (
    <section className="UpdateProfileModal modal-holder">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="UpdateProfileModal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Profile Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="main_modal_div">
            <div className="btn_holder">
              {/* {addressType?.map((val) => (
                <div
                  key={val?.id}
                  className="personal_btn_div"
                  onClick={() => {
                    setActiveBtn(val?.id);
                    setShwoBusinessFields(false);
                  }}
                >
                  {val?.id === 1 ? (
                    <OrangeFilledSquareBtn btnText={val?.name} />
                  ) : (
                    <OrangeOutlineGrayFilledBtn btnText={val?.name} />
                  )}
                </div>
              ))} */}
              <div
                className="personal_btn_div"
                onClick={() => {
                  setActiveBtn("Personal");
                  setShwoBusinessFields(false);
                }}
              >
                {activeBtn === "Personal" ? (
                  <OrangeFilledSquareBtn btnText="Personal" />
                ) : (
                  <OrangeOutlineGrayFilledBtn btnText="Personal" />
                )}
              </div>
              <div
                className="business_btn_div"
                onClick={() => {
                  setActiveBtn("Business");
                  setShwoBusinessFields(true);
                }}
              >
                {activeBtn === "Business" ? (
                  <OrangeFilledSquareBtn btnText="Business" />
                ) : (
                  <OrangeOutlineGrayFilledBtn btnText="Business" />
                )}
              </div>
            </div>

            <div className="form_holder">
              <Form onSubmit={handleSubmit(onSubmit)}>
                {!shwoBusinessFields ? (
                  <div className="personal_form">
                    <Form.Group className="form-group">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        {...register("name", {
                          required: "First name required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.name,
                          "is-valid": getValues("name"),
                        })}
                      />
                      {errors?.name && (
                        <sup className="text-danger">
                          {errors?.name?.message}
                        </sup>
                      )}
                    </Form.Group>

                    <Form.Group className="form-group">
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: RegxExpression.email,
                            message: "Invalid email ",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.email,
                          "is-valid": getValues("email"),
                        })}
                      />
                      {errors?.email && (
                        <sup className="text-danger">
                          {errors?.email?.message}
                        </sup>
                      )}
                    </Form.Group>

                    <Form.Group className="form-group">
                      <Controller
                        name="contact_no"
                        control={control}
                        rules={{
                          required: "Contact number is required",
                          minLength: {
                            value: 10,
                            message: "Number should be at least 10 characters",
                          },
                        }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                              "is-valid": getValues("contact_no"),
                            })}
                            // onChange={(value) => field.onChange(value)}
                            type="text"
                            placeholder="Mobile Number"
                            maxLength={10}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              ); // Removes non-numeric characters
                              field.onChange(numericValue);
                            }}
                          />
                        )}
                      />
                      {errors?.contact_no && (
                        <sup className="text-danger">
                          {errors?.contact_no?.message}
                        </sup>
                      )}

                      <p className="note_text">
                        Your phone number will be used for order tracking &
                        updates
                      </p>
                    </Form.Group>

                    <Form.Group className="form-group">
                      <Form.Control
                        type={"text"}
                        placeholder="Create Password (optional)"
                        name="password"
                        {...register("password", {
                          // required: "Password is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be at least 8 characters long",
                          },
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                            message:
                              "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                          },
                        })}
                      />
                      {errors?.password && (
                        <sup className="text-danger">
                          {errors?.password?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>
                ) : (
                  <div className="business_form">
                    <Row>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            {...register("name", {
                              required: "First name required",
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.name,
                              "is-valid": getValues("name"),
                            })}
                          />
                          {errors?.name && (
                            <sup className="text-danger">
                              {errors?.name?.message}
                            </sup>
                          )}
                        </Form.Group>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Form.Control
                            type="text"
                            name="email"
                            placeholder="Email"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: RegxExpression.email,
                                message: "Invalid email ",
                              },
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.email,
                              "is-valid": getValues("email"),
                            })}
                          />
                          {errors?.email && (
                            <sup className="text-danger">
                              {errors?.email?.message}
                            </sup>
                          )}
                        </Form.Group>
                      </div>
                    </Row>

                    <Row>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Controller
                            name="industry_id"
                            control={control}
                            rules={{ required: "Industry is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={industry}
                                placeholder="Industry"
                                onInputChange={(val) => {
                                  dispatch(getAllIndustry(val));
                                }}
                              />
                            )}
                          />
                          {errors?.industry_id && (
                            <Form.Text className="text-danger">
                              {errors?.industry_id?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Controller
                            name="department_id"
                            control={control}
                            rules={{ required: "Department is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={department}
                                placeholder="Department"
                                onInputChange={(val) => {
                                  dispatch(getAllDepartment(val));
                                }}
                              />
                            )}
                          />
                          {errors?.department_id && (
                            <Form.Text className="text-danger">
                              {errors?.department_id?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                    </Row>

                    <Row>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Controller
                            name="company_size_id"
                            control={control}
                            rules={{ required: "Company Size is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={companysize}
                                placeholder="Company Size"
                                onInputChange={(val) => {
                                  dispatch(getAllICompanySize(val));
                                }}
                              />
                            )}
                          />
                          {errors?.company_size_id && (
                            <Form.Text className="text-danger">
                              {errors?.company_size_id?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Form.Control
                            type={"text"}
                            placeholder="Create Password (optional)"
                            name="password"
                            {...register("password", {
                              // required: "Password is required",
                              minLength: {
                                value: 8,
                                message:
                                  "Password must be at least 8 characters long",
                              },
                              pattern: {
                                value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                message:
                                  "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                              },
                            })}
                          />
                          {errors?.password && (
                            <sup className="text-danger">
                              {errors?.password?.message}
                            </sup>
                          )}
                        </Form.Group>
                      </div>
                    </Row>

                    <Row>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <Form.Group className="form-group">
                          <Controller
                            name="contact_no"
                            control={control}
                            rules={{
                              required: "Contact number is required",
                              minLength: {
                                value: 10,
                                message:
                                  "Number should be at least 10 characters",
                              },
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                className={classNames("", {
                                  "is-invalid": errors?.contact_no,
                                  "is-valid": getValues("contact_no"),
                                })}
                                // onChange={(value) => field.onChange(value)}
                                type="text"
                                placeholder="Mobile Number"
                                maxLength={10}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ); // Removes non-numeric characters
                                  field.onChange(numericValue);
                                }}
                              />
                            )}
                          />
                          {errors?.contact_no && (
                            <sup className="text-danger">
                              {errors?.contact_no?.message}
                            </sup>
                          )}
                        </Form.Group>
                      </div>
                    </Row>
                  </div>
                )}

                <Form.Group className="form-group">
                  <Form.Check
                    type="checkbox"
                    id="agree"
                    label="I have an immediate Requirement. Please call me back."
                    {...register("immediate_requirement")}
                  />
                </Form.Group>

                <div
                  className="otp_btn"
                  // onClick={() => {
                  //   props?.onHide();
                  //   setShowSuccessModal(true);
                  // }}
                >
                  <Orange_Round_Arrow_Btn
                    btn_name="Save & Generate OTP"
                    type={"submit"}
                  />
                </div>
              </Form>
            </div>

            <div className="info_text_holder">
              <p className="why_text">
                Why sign up with SM PRINTOUT MEDIA as a Business?{" "}
              </p>

              <p className="reason_text">
                - Buy at special business pricing on orders greater than
                Rs.10,000.
              </p>
              <p className="reason_text">
                {" "}
                - Claim GST Input Tax Credit Save More With Business Deals.
              </p>
              <p className="reason_text">
                - Dedicated Business Account Manager for you.
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ProfileUpdateModal
        data={data}
        show={showSuccessModal}
        onHide={() => {
          setShowSuccessModal(false);
        }}
        successText="Profile Updated Successfully!"
      />
    </section>
  );
}

export default UpdateProfileModal;
